export default {
    user(state) {
        return state.localStorage.getItem("user");
    },
    setToken(state, token) {
        state.token = token;
    },
    updateCountryCode(state,payload){
        state.country_code = payload;
    },
    updateTrackerStatus(state, payload) {
        state.tracker = payload;
    },
    updataProfile_pic(state, payload) {
        state.profile_pic = payload;
    },
    updateNewPublisher(state) {
        return state.new_publisher;
    },
};
